export const APIKEY = 'AIzaSyCxZzhbTrwMvI3bz-YgIU_ZEU_3J5yYWvI';
// tslint:disable-next-line:max-line-length
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZnJvbW8iLCJhIjoiY2lxeWN1dDk4MDF0Y2Zza3FlOW03aG93ayJ9.vN4_HcG9if1Jb5-lm5K7Sw'; // Set your mapbox token here
export const URL_CONFIG = {
    helpUrl: 'https://www.publicdefenders.us/',
    logoUrl: 'https://www.publicdefenders.us/',
    logo: './NAPD_round-logo.jpeg',
    homeUrl: 'https://www.publicdefenders.us/',
    // googleGeocoderUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
    googleGeocoderUrl:  'https://napd-geocoder.herokuapp.com/',
    // googleGeocoderUrl: 'http://localhost:8000',
    mapboxGeocoderUrl: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
};
